import { ChangeDetectionStrategy, Component, computed, inject, input, output, TemplateRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BundleType, EntityTypeId, FieldName, UserRole } from '../../models';
import { ProfileService } from '../../services/profile.service';

type SocialWallMediaType = 'image' | 'video' | 'audio';

const MEDIA_FIELDS: { field: string, type: SocialWallMediaType }[] = [
  { field: 'mediaImage', type: 'image' },
  { field: 'mediaVideo', type: 'video' },
  { field: 'mediaAudio', type: 'audio' }
];

@Component({
  selector: 'lib-social-wall-card',
  templateUrl: './social-wall-card.component.html',
  styleUrl: './social-wall-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SocialWallCardComponent {

  public readonly entityTypeId = EntityTypeId;
  public readonly bundleType = BundleType;
  public readonly fieldName = FieldName;

  public item = input<any>({});
  public contextTemplate = input<TemplateRef<any>>();


  public open = output<void>();
  public like = output<void>();
  public pin = output<void>();
  public openLinkedContent = output<any>();

  private readonly profileService = inject(ProfileService);
  private readonly currentProfile = toSignal(this.profileService.getCurrentProfile());

  public media = computed<{ type: SocialWallMediaType, value: any } | null>(() => {
    const item = this.item();
    const media = MEDIA_FIELDS.find(({ field }) => !!item?.[field]);

    return media ? { type: media.type, value: item[media.field] } : null;
  });

  public isAdmin = computed(() => this.currentProfile()?.roles.includes(UserRole.ADMIN));
  public canShowPin = computed(() => !!this.item()?.pinned || this.isAdmin());
  public canTogglePin = computed(() => this.isAdmin());

  public stopPropagation(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  public toggleLike(event: Event): void {
    this.stopPropagation(event);
    this.like.emit();
  }

  public togglePin(event: Event): void {
    this.stopPropagation(event);

    if (this.canTogglePin()) {
      this.pin.emit();
    }
  }

  public openLinkToContent(event: Event, content: any): void {
    this.stopPropagation(event);
    this.openLinkedContent.emit(content);
  }
}
